"use client";

import { PublicBookingStepper, PreferencesProvider, CalendarContextProvider } from "@west-tennessee-consulting/ui";
import { PublicBookingLayout } from "@/components/crm/calendar/PublicBookingLayout";
import { PublicBookingAdminPanel } from "@/components/crm/calendar/PublicBookingAdminPanel";

export default function PublicBookingPageWrapper() {
  return (
    <PreferencesProvider>
      <CalendarContextProvider enabled={true}>
        <PublicBookingLayout>
          <PublicBookingStepper />
        </PublicBookingLayout>
        {/* Admin-only link builder; renders nothing for anonymous bookers. */}
        <PublicBookingAdminPanel />
      </CalendarContextProvider>
    </PreferencesProvider>
  );
}
